import { useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { Post } from "../../../../utils/request"
import { Show } from "../../../../actions/SnackbarActions"
import FormBody from "./FormBody";

const TestimonialAdd = () => {
    const [popup, SetPopup] = useState(false);
    const [popupMessage, SetPopupMessage] = useState("");

    const [loading, SetLoading] = useState(false);

    const userId = useSelector(store => store.AppReducer.user?.id);

    const dispatch = useDispatch();
    const history = useHistory();

    const Submit = async (data) => {
        if (!data?.image) {
            SetPopup(true);
            SetPopupMessage("Insira uma imagem");
            return;
        } else if (!data?.name) {
            SetPopup(true);
            SetPopupMessage("Insira um nome!");
            return;
        } else if (!data?.testimonial) {
            SetPopup(true);
            SetPopupMessage("Insira um depoimento!");
            return;
        } else if (!data?.profession) {
            SetPopup(true);
            SetPopupMessage("Insira uma profissao!");
            return;
        }

        let form = new FormData();
        form.append("image", data.image);
        form.append("name", data.name);
        form.append("testimonial", data.testimonial);
        form.append("profession", data.profession);

        SetLoading(true);
        let response = await Post("site-rt/testimonial/create", form);
        SetLoading(false);
        dispatch(Show({
            show: true,
            message: response?.message,
            severity: response?.severity,
            buttonActionText: "Ver",
            // ButtonAction: () => history.push(`/courses/view/${response?.courseId}`)
        }));

        if (response?.status === true) history.push("/site-rt/depoimentos");
    }

    return (
        <div className="card">
            <SweetAlert
                warning
                show={popup}
                title="Atenção!"
                confirmBtnText="Ok"
                onConfirm={() => SetPopup(false)}
            >
                {popupMessage}
            </SweetAlert>
            <div className="card-body">
                <h2 className="title">Criar Depoimento</h2>
                <p>Aqui são criadas os depoimentos que apareceram no site do RT</p>
                <br/>
                <FormBody
                    OnConfirm={data => Submit(data)}
                    loading={loading}
                />
            </div>
        </div>
    );
}

export default TestimonialAdd;